/**
 * src/client/main.ts
 *
 * Application bootstrap + screen router.
 * Mounts styles and the start screen; the screen router handles all transitions.
 */

import "./styles.css";
import { mountScreens } from "./ui/screens.js";

const app = document.getElementById("app");
if (!app) {
  throw new Error("Mount element #app not found");
}

mountScreens(app);
